/* ============================================================
   Uitsneden per ontwerp — TOON atelier
   Bestand: assets/gallery-wall-uitsneden.js

   Waar zit het gat, hoe groot is het, en welke vorm heeft het.
   Alle maten in centimeters, overgenomen uit Hannahs ontwerpoverzicht
   en nagerekend: randen plus uitsnede geven exact de buitenmaat.

   UITSNEDEN[sleutel].formaten['30x40'] beschrijft één buitenformaat:
     binnen   [breedte, hoogte] van de uitsnede
     links    afstand tot de linkerrand; ontbreekt = horizontaal gecentreerd
     rechts   afstand tot de rechterrand, in plaats van links
     boven    afstand tot de bovenrand;  ontbreekt = verticaal gecentreerd
     onder    afstand tot de onderrand, in plaats van boven
     aantal   meer dan één uitsnede
     tussen   ruimte tussen die uitsneden
     richting 'verticaal' zet ze onder elkaar; standaard naast elkaar
     hoek     graden gedraaid (negatief = tegen de klok in; 350° in het
              overzicht is hier -10)

   vorm: 'rechthoek', of een sleutel uit gallery-wall-vormen.js,
   of 'raster:<sleutel>' voor de twaalfvoudige ontwerpen.
   ============================================================ */

(function (root) {
  'use strict';

  var UITSNEDEN = {

    /* ---- organische vormen: eigen omtrek, gecentreerd ---- */

    wolk: {
      naam: 'Wolk organische vorm', vorm: 'wolk', formaten: {
        '21x30': { binnen: [9.5, 14] },
        '30x40': { binnen: [14, 19.5] },
        '40x50': { binnen: [17, 24] },
        '50x70': { binnen: [22, 32] }
      }
    },
    asymmetrischRond: {
      naam: 'Asymmetrisch rond', vorm: 'asymmetrischRond', formaten: {
        '21x30': { binnen: [15, 21.5] },
        '30x40': { binnen: [19.5, 29.5] },
        '40x50': { binnen: [28, 39] },
        '50x70': { binnen: [35, 53] }
      }
    },
    golvendFrame: {
      naam: 'Golvend frame', vorm: 'golvendFrame', formaten: {
        '21x30': { binnen: [16.5, 25] },
        '30x40': { binnen: [23, 33] },
        '40x50': { binnen: [32, 42] },
        '50x70': { binnen: [40, 60] }
      }
    },
    rondeHoekenFrame: {
      naam: 'Ronde hoeken frame', vorm: 'rondeHoekenFrame', formaten: {
        '21x30': { binnen: [16, 23] },
        '30x40': { binnen: [22, 32] },
        '40x50': { binnen: [29, 41] },
        '50x70': { binnen: [38, 56] }
      }
    },
    balans: {
      naam: 'Balans organische vorm', vorm: 'balans', formaten: {
        '21x30': { binnen: [16, 25] },
        '30x40': { binnen: [23, 34] },
        '40x50': { binnen: [29, 43] },
        '50x70': { binnen: [39, 58] }
      }
    },

    /* ---- polaroids ---- */

    polaroidMini: {
      naam: 'Polaroid Instax mini', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [5.2, 8.1], links: 7.9, boven: 9.0 },
        '30x40': { binnen: [5.2, 8.1], links: 12.4, boven: 13.0 }
      }
    },
    polaroidMiniSchuin: {
      naam: 'Schuine Polaroid Instax mini', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [5.2, 8.1], hoek: -10 },
        '30x40': { binnen: [5.2, 8.1], hoek: -10 },
        '32x32': { binnen: [5.2, 8.1], hoek: -10 }
      }
    },
    polaroidMini2: {
      naam: '2x Polaroid Instax mini off-center', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [5.2, 8.1], links: 2.5, boven: 10.95, aantal: 2, tussen: 1.5 },
        '30x40': { binnen: [5.2, 8.1], links: 2.5, boven: 15.95, aantal: 2, tussen: 1.5 }
      }
    },
    polaroidMiniHoek: {
      naam: 'Polaroid Instax mini in de hoek', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [5.2, 8.1], links: 2.5, boven: 19.4 }
      }
    },
    polaroidSquare: {
      naam: 'Polaroid Instax Square', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [7.0, 8.3], links: 7.0, boven: 9.0 },
        '30x40': { binnen: [7.0, 8.3], links: 11.5, boven: 13.0 }
      }
    },
    polaroidSquareHoek: {
      naam: 'Polaroid Instax Square in de hoek', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [7.0, 8.3], links: 4.0, boven: 27.7 }
      }
    },
    polaroidSquareSchuin: {
      naam: 'Schuine Polaroid Instax Square', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [7.0, 8.3], hoek: -10 },
        '30x40': { binnen: [7.0, 8.3], hoek: -10 },
        '32x32': { binnen: [7.0, 8.3], hoek: -10 }
      }
    },
    polaroidWide: {
      naam: 'Polaroid Instax wide', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [10.4, 8.1], links: 5.3, boven: 8.6 },
        '30x40': { binnen: [10.4, 8.1], links: 9.8, boven: 12.85 }
      }
    },
    // Het raster is 3 bij 4 polaroids met 2,0 cm ertussen horizontaal en
    // 1,5 cm verticaal — maten uit 12xpolaroid.svg, gecentreerd op het karton.
    polaroid12mini: {
      naam: '12x Polaroid Instax mini', vorm: 'raster:polaroid12mini', formaten: {
        '40x50': { binnen: [19.63, 36.94] },
        '50x70': { binnen: [19.63, 36.94] }
      }
    },
    polaroid12square: {
      naam: '12x Polaroid Instax square', vorm: 'raster:polaroid12square', formaten: {
        '40x50': { binnen: [24.99, 37.75] },
        '50x70': { binnen: [24.99, 37.75] }
      }
    },

    /* ---- foto's en kioskfoto ---- */

    // Elke fotostrip bestaat voor strips van 5x15 cm en van 4x20 cm. De uitsnede
    // voor 4x20 is 3,7 x 19,7, net als bij de RVS fotostrip lijst.
    kioskfoto: {
      naam: 'Fotostrip (kioskfoto)', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [4.7, 14.7], links: 8.15, boven: 7.65 },
        '30x40': { binnen: [4.7, 14.7], links: 12.65, boven: 12.65 }
      }
    },
    kioskfoto4x20: {
      naam: 'Fotostrip (kioskfoto) 4x20', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [3.7, 19.7] },
        '30x40': { binnen: [3.7, 19.7] }
      }
    },
    // Linksonder: 4 cm van de linkerrand en 4 cm van de onderrand, bij beide maten.
    kioskfotoHoek: {
      naam: 'Fotostrip (kioskfoto) in de hoek', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [4.7, 14.7], links: 4.0, onder: 4.0 }
      }
    },
    kioskfotoHoek4x20: {
      naam: 'Fotostrip (kioskfoto) 4x20 in de hoek', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [3.7, 19.7], links: 4.0, onder: 4.0 }
      }
    },
    foto1015RondeHoeken: {
      naam: 'Ronde hoeken 10x15 foto', vorm: 'rondeHoeken1015', formaten: {
        '21x30': { binnen: [9.5, 14.5] },
        '30x40': { binnen: [9.5, 14.5] }
      }
    },
    foto1015Schuin: {
      naam: 'Schuine 10x15 foto', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [9.5, 14.5], hoek: -10 },
        '30x40': { binnen: [9.5, 14.5], hoek: -10 }
      }
    },
    foto1015Hoek: {
      naam: '10x15 foto in de hoek', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [9.5, 14.5], links: 4.0, onder: 4.0 },
        '40x50': { binnen: [9.5, 14.5], links: 4.0, boven: 31.5 }
      }
    },
    // A6 (10,5 x 14,8) krijgt bij dezelfde drie ontwerpen een uitsnede van
    // 10 x 14,3, op dezelfde plek en in dezelfde vorm (Hannah, 3 nov 2026).
    fotoA6RondeHoeken: {
      naam: 'Ronde hoeken A6 foto', vorm: 'rondeHoeken1015', formaten: {
        '21x30': { binnen: [10, 14.3] },
        '30x40': { binnen: [10, 14.3] }
      }
    },
    fotoA6Schuin: {
      naam: 'Schuine A6 foto', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [10, 14.3], hoek: -10 },
        '30x40': { binnen: [10, 14.3], hoek: -10 }
      }
    },
    fotoA6Hoek: {
      naam: 'A6 foto in de hoek', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [10, 14.3], links: 4.0, onder: 4.0 },
        '40x50': { binnen: [10, 14.3], links: 4.0, boven: 31.7 }
      }
    },
    foto1520Hoek: {
      naam: '15x20 foto in de hoek', vorm: 'rechthoek', formaten: {
        '50x70': { binnen: [14.5, 19.5], links: 6.0, boven: 44.5 }
      }
    },
    polaroidMiniRondeHoeken: {
      naam: 'Ronde hoeken Polaroid Instax mini', vorm: 'rondeHoekenMini', formaten: {
        '21x30': { binnen: [5.2, 8.1], links: 7.9, boven: 9.0 },
        '30x40': { binnen: [5.2, 8.1], links: 12.4, boven: 13.0 }
      }
    },
    polaroidSquareRondeHoeken: {
      naam: 'Ronde hoeken Polaroid Instax square', vorm: 'rondeHoekenMini', formaten: {
        '21x30': { binnen: [7.0, 8.3], links: 7.0, boven: 9.0 },
        '30x40': { binnen: [7.0, 8.3], links: 11.5, boven: 13.0 }
      }
    },
    polaroidWideRondeHoeken: {
      naam: 'Ronde hoeken Polaroid Instax wide', vorm: 'rondeHoekenMini', formaten: {
        '21x30': { binnen: [10.4, 8.1], links: 5.3, boven: 8.6 },
        '30x40': { binnen: [10.4, 8.1], links: 9.8, boven: 12.85 }
      }
    },

    /* ---- meervoudig, in de hoek of op een rij ---- */

    // Twee wides onder elkaar, uitgelijnd op de rechter- en onderrand.
    wideX2Hoek: {
      naam: 'Polaroid wide x2 in het hoekje', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [10.4, 8.1], rechts: 4.5, onder: 6.5, aantal: 2, tussen: 1.5,
                   richting: 'verticaal' },
        '40x50': { binnen: [10.4, 8.1], rechts: 6.5, onder: 8.5, aantal: 2, tussen: 1.5,
                   richting: 'verticaal' }
      }
    },

    // Twee kioskfoto-stroken naast elkaar, 2,5 cm van de rand, verticaal gecentreerd.
    kioskfoto2: {
      naam: '2x Fotostrip (kioskfoto) off-center', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [4.7, 14.7], links: 2.5, aantal: 2, tussen: 1.5 },
        '40x50': { binnen: [4.7, 14.7], links: 2.5, aantal: 2, tussen: 1.5 }
      }
    },
    kioskfoto2x4x20: {
      naam: '2x Fotostrip (kioskfoto) 4x20 off-center', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [3.7, 19.7], links: 2.5, aantal: 2, tussen: 1.5 },
        '40x50': { binnen: [3.7, 19.7], links: 2.5, aantal: 2, tussen: 1.5 }
      }
    },

    // Twee liggende 15x20 foto's onder elkaar, rechtsonder in de hoek.
    foto1520X2Hoek: {
      naam: '2x 15x20 foto in de hoek', vorm: 'rechthoek', formaten: {
        '50x70': { binnen: [19.5, 14.5], rechts: 6.5, onder: 8.5, aantal: 2, tussen: 1.5,
                   richting: 'verticaal' }
      }
    },

    // Verticale reeks: het aantal foto's hangt van het buitenformaat af,
    // de maat van het gekozen binnenformaat. Altijd 2 cm ertussen.
    reeksMini: {
      naam: 'Verticale reeks, polaroid mini', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [5.2, 8.1], aantal: 2, tussen: 2, richting: 'verticaal' },
        '40x50': { binnen: [5.2, 8.1], aantal: 3, tussen: 2, richting: 'verticaal' },
        '50x70': { binnen: [5.2, 8.1], aantal: 4, tussen: 2, richting: 'verticaal' }
      }
    },
    reeksSquare: {
      naam: 'Verticale reeks, polaroid square', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [7.0, 8.3], aantal: 2, tussen: 2, richting: 'verticaal' },
        '40x50': { binnen: [7.0, 8.3], aantal: 3, tussen: 2, richting: 'verticaal' },
        '50x70': { binnen: [7.0, 8.3], aantal: 4, tussen: 2, richting: 'verticaal' }
      }
    },
    reeksWide: {
      naam: 'Verticale reeks, polaroid wide', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [10.4, 8.1], aantal: 2, tussen: 2, richting: 'verticaal' },
        '40x50': { binnen: [10.4, 8.1], aantal: 3, tussen: 2, richting: 'verticaal' },
        '50x70': { binnen: [10.4, 8.1], aantal: 4, tussen: 2, richting: 'verticaal' }
      }
    },

    /* ---- posters ---- */

    poster: {
      naam: 'Standaard poster', vorm: 'rechthoek', formaten: {
        '30x40': { binnen: [20, 28.7] },
        '40x50': { binnen: [29, 39] },
        '50x70': { binnen: [39, 49] }
      }
    },
    posterLiggend: {
      naam: 'Poster liggend, hoog geplaatst', vorm: 'rechthoek', formaten: {
        '40x50': { binnen: [28.7, 20], links: 5.65, boven: 5 }
      }
    },
    posterHoog: {
      naam: 'Poster staand, hoog geplaatst', vorm: 'rechthoek', formaten: {
        '50x70': { binnen: [29, 39], links: 5, boven: 26 }
      }
    },
    posterA4Midden: {
      naam: 'A4-poster staand, gecentreerd', vorm: 'rechthoek', formaten: {
        '40x50': { binnen: [20, 28.7] }
      }
    },
    poster3040Midden: {
      naam: '30x40-poster gecentreerd', vorm: 'rechthoek', formaten: {
        '50x70': { binnen: [29, 39] }
      }
    },

    /* ---- schuine kubus: vierkant, per formaat een eigen maat ---- */

    schuineKubus: {
      naam: 'Schuine kubus', vorm: 'rechthoek', formaten: {
        '21x30': { binnen: [9, 9], hoek: -10 },
        '30x40': { binnen: [12, 12], hoek: -10 },
        '40x50': { binnen: [16, 16], hoek: -10 },
        '50x70': { binnen: [20, 20], hoek: -10 },
        '32x32': { binnen: [11, 11], hoek: -10 }
      }
    }
  };

  // De buitenmaten waarop gerekend wordt, in centimeters.
  var BUITEN = {
    '21x30': [21, 30],
    '30x40': [30, 40],
    '40x50': [40, 50],
    '50x70': [50, 70],
    '32x32': [32, 32]
  };

  // Zet een Shopify-optiewaarde om naar een sleutel hierboven.
  function formaatSleutel(tekst) {
    if (!tekst) return null;
    var t = String(tekst).toLowerCase().replace(/\s/g, '');
    if (t.indexOf('a4') !== -1 || t.indexOf('21x29,7') !== -1 || t.indexOf('21x30') !== -1) return '21x30';
    if (t.indexOf('30x40') !== -1) return '30x40';
    if (t.indexOf('40x50') !== -1) return '40x50';
    if (t.indexOf('50x70') !== -1) return '50x70';
    if (t.indexOf('32x32') !== -1) return '32x32';
    return null;
  }

  /**
   * Geeft de gaten van een ontwerp op een buitenformaat, in centimeters
   * vanaf de linkerbovenhoek van het passe-partout:
   *   [{ x, y, w, h, hoek, vorm }]
   * vorm is 'rechthoek' of een sleutel uit gallery-wall-vormen.js.
   */
  function gaten(sleutel, formaat) {
    var o = UITSNEDEN[sleutel];
    if (!o) return null;
    var f = formaatSleutel(formaat);
    var spec = f && o.formaten[f];
    if (!spec) return null;
    var buiten = BUITEN[f];
    var iw = spec.binnen[0], ih = spec.binnen[1];
    var aantal = spec.aantal || 1;
    var tussen = spec.tussen || 0;
    var verticaal = spec.richting === 'verticaal';
    var totaalB = verticaal ? iw : iw * aantal + tussen * (aantal - 1);
    var totaalH = verticaal ? ih * aantal + tussen * (aantal - 1) : ih;

    var x0;
    if (spec.links !== undefined) x0 = spec.links;
    else if (spec.rechts !== undefined) x0 = buiten[0] - spec.rechts - totaalB;
    else x0 = (buiten[0] - totaalB) / 2;

    var y0;
    if (spec.boven !== undefined) y0 = spec.boven;
    else if (spec.onder !== undefined) y0 = buiten[1] - spec.onder - totaalH;
    else y0 = (buiten[1] - totaalH) / 2;

    if (o.vorm.indexOf('raster:') === 0) {
      var naam = o.vorm.slice(7);
      var vakjes = root.GalleryWallVormen && root.GalleryWallVormen.vakjes(naam, iw, ih);
      if (!vakjes) return null;
      return vakjes.map(function (v) {
        return { x: x0 + v.x, y: y0 + v.y, w: v.w, h: v.h, hoek: 0, vorm: 'rechthoek' };
      });
    }

    var uit = [];
    for (var i = 0; i < aantal; i++) {
      uit.push({
        x: x0 + (verticaal ? 0 : i * (iw + tussen)),
        y: y0 + (verticaal ? i * (ih + tussen) : 0),
        w: iw,
        h: ih,
        hoek: spec.hoek || 0,
        vorm: o.vorm
      });
    }
    return uit;
  }

  /* ---- vensters op de fotostrip-maten ---- */

  // Dezelfde uitsnede bij alle fotostrip-producten (Hannah, 15 okt 2026):
  // 3 mm overlap rondom de strip.
  var STRIP = {
    '5x15': [4.7, 14.7],
    '4x20': [3.7, 19.7]
  };

  // De RVS-lijsten, per handle. Eén gezet stuk staal met een gecentreerd
  // venster, gemeten op de technische tekening en nagemeten op de productfoto.
  // vensters: per binnenformaat (de varianttitel); '' als er maar één is.
  var RVS = {
    'rvs-fotostrip-lijst-15x35-cm': { buiten: [15, 35], vensters: STRIP },
    'rvs-polaroid-lijst-a4':        { buiten: [21, 29.7], vensters: { '': [5.1, 8.1] } }
  };

  // Welk venster hoort bij deze variant? "5x15 cm" -> STRIP['5x15'].
  function venster(tabel, variantTitel) {
    var t = String(variantTitel || '').toLowerCase().replace(/\s/g, '');
    var sleutels = Object.keys(tabel);
    for (var i = 0; i < sleutels.length; i++) {
      if (sleutels[i] && t.indexOf(sleutels[i]) !== -1) return tabel[sleutels[i]];
    }
    return tabel[sleutels[0]];
  }

  // Eén gecentreerd venster in een vlak van w bij h, in centimeters.
  function midden(w, h, maat) {
    return [{ x: (w - maat[0]) / 2, y: (h - maat[1]) / 2, w: maat[0], h: maat[1], hoek: 0, vorm: 'rechthoek' }];
  }

  function formatenVan(sleutel) {
    var o = UITSNEDEN[sleutel];
    return o ? Object.keys(o.formaten) : [];
  }

  root.GalleryWallUitsneden = {
    lijst: UITSNEDEN,
    buiten: BUITEN,
    gaten: gaten,
    formaatSleutel: formaatSleutel,
    formatenVan: formatenVan,
    namen: Object.keys(UITSNEDEN),
    strip: STRIP,
    stripVenster: function (titel) { return venster(STRIP, titel); },
    rvs: function (handle) { return RVS[handle] || null; },
    rvsVenster: function (handle, titel) { return RVS[handle] ? venster(RVS[handle].vensters, titel) : null; },
    midden: midden
  };
})(window);
